{
  "familyId": "SPR-LEEN-GRIEKS",
  "questions": [
    {
      "id": "SPR-LEEN-GRIEKS-001",
      "familyId": "SPR-LEEN-GRIEKS",
      "module": "SpellingRegel",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_grieks",
      "questionType": "multiple_choice",
      "question": "Welk woord komt uit het Grieks?",
      "options": ["psychologie", "restaurant", "computer", "bureau"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Griekse leenwoorden", "content": "Woorden met 'psych-', 'phil-', 'theo-', 'bio-' komen uit het Grieks. Psychologie = psyche (ziel) + logos (leer).", "icon": "lightbulb" } }
      ],
      "conceptId": "grieks_herkennen",
      "variantIndex": 1,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Psychologie komt uit het Grieks: psyche (ziel) + logos (leer/wetenschap). Restaurant is Frans, computer is Engels, bureau is Frans. Hoe herken je Griekse woorden? Let op voorvoegsels als psych-, bio-, theo-, phil- en achtervoegsels als -logie, -grafie, -scopie. Als je een onbekend woord tegenkomt, kijk dan of het zo'n Grieks woorddeel bevat.",
        "solutionSteps": ["Psychologie: psyche (Grieks: ziel) + logos (Grieks: leer)", "Restaurant = Frans, computer = Engels, bureau = Frans", "Herken Griekse voorvoegsels: psych-, bio-, theo-, phil-", "Check: bevat het woord een Grieks woorddeel? Zo ja → waarschijnlijk Grieks"],
        "distractorExplanations": {
          "0": "Goed! Psychologie komt uit het Grieks: psyche (ziel) + logos (leer). Het voorvoegsel psych- is een kenmerkend Grieks woorddeel.",
          "1": "Restaurant komt uit het Frans (restaurer = herstellen). Onthoud: -ant/-ent is vaak Frans.",
          "2": "Computer komt uit het Engels (to compute = berekenen). Onthoud: -er is vaak Engels.",
          "3": "Bureau komt uit het Frans. Onthoud: -eau is typisch Frans."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.greek-origin-confused", "label": "Frans woord als Grieks gezien", "optionIndex": 1 },
          { "id": "spr.greek-origin-confused", "label": "Engels woord als Grieks gezien", "optionIndex": 2 },
          { "id": "spr.greek-origin-confused", "label": "Frans woord als Grieks gezien", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-LEEN-GRIEKS-002",
      "familyId": "SPR-LEEN-GRIEKS",
      "module": "SpellingRegel",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_grieks",
      "questionType": "multiple_choice",
      "question": "In een werkstuk over denkers schrijft een leerling over 'de liefde voor wijsheid'. Het Griekse woord hiervoor is 'philosophia'. Hoe schrijf je dit in het Nederlands?",
      "options": ["filosofy", "fillosofie", "filosofie", "fylosofie"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Griekse ph → f", "content": "In het Nederlands schrijven we Griekse woorden met 'f' in plaats van 'ph': philosophy → filosofie. De uitgang -y wordt in het Nederlands -ie.", "icon": "lightbulb" } }
      ],
      "conceptId": "grieks_spelling_f",
      "variantIndex": 2,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "In het Nederlands schrijven we het Griekse 'ph' als 'f': philosophy → filosofie. De Engelse uitgang -y wordt in het Nederlands -ie. Let op: één l (filo-), niet twee (fillo-).",
        "solutionSteps": ["Grieks ph → Nederlands f", "Engelse -y → Nederlandse -ie", "Eén l: filo- (niet fillo-)", "Philosophy → filosofie"],
        "distractorExplanations": {
          "0": "Je hebt de Engelse uitgang -y gebruikt. In het Nederlands is het -ie: filosofie, niet filosofy. Onthoud: Engelse -y → Nederlandse -ie.",
          "1": "Je schreef een dubbele l: 'fillosofie'. Maar het Griekse woord heeft maar één l: philosophia → filosofie. Onthoud: filo- (één l), niet fillo-.",
          "2": "Goed! Filosofie — met f (niet ph) en -ie (niet -y). In het Nederlands passen we de Griekse spelling aan: ph wordt f.",
          "3": "Je schreef 'fy' in plaats van 'fi'. De Griekse 'ph' wordt in het Nederlands gewoon 'f', gevolgd door 'i': filosofie. Onthoud: ph → f, niet fy."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.greek-spelling-english", "label": "Engelse uitgang -y behouden", "optionIndex": 0 },
          { "id": "spr.greek-spelling-english", "label": "Dubbele l (fillosofie)", "optionIndex": 1 },
          { "id": "spr.greek-spelling-english", "label": "Fy- i.p.v. fi-", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-LEEN-GRIEKS-003",
      "familyId": "SPR-LEEN-GRIEKS",
      "module": "SpellingRegel",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_grieks",
      "questionType": "multiple_choice",
      "question": "Je leest in je biologieboek over 'biodiversiteit'. Uit de context leid je af dat 'bio-' iets te maken heeft met... Wat betekent dit Griekse voorvoegsel?",
      "options": ["aarde", "leven", "water", "lucht"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Griekse voorvoegsels", "content": "bio- = leven (biologie = leer van het leven). geo- = aarde, hydro- = water, aero- = lucht.", "icon": "lightbulb" } }
      ],
      "conceptId": "grieks_voorvoegsel",
      "variantIndex": 3,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Bio- komt uit het Grieks en betekent 'leven'. Biologie = leer van het leven. Biograaf = schrijver over iemands leven. Andere Griekse voorvoegsels: geo- = aarde, hydro- = water, aero- = lucht. Een handige manier om ze te onthouden: denk aan een bekend woord met dat voorvoegsel en leid de betekenis daaruit af.",
        "solutionSteps": ["bio- = leven (Grieks: bios)", "biologie = leer van het leven", "biograaf = schrijver over iemands leven", "Onthoud-strategie: denk aan een bekend woord (biologie) om de betekenis af te leiden"],
        "distractorExplanations": {
          "0": "Aarde is 'geo-' in het Grieks (geografie = beschrijving van de aarde). Bio- = leven. Onthoud: bio = leven, geo = aarde.",
          "1": "Goed! Bio- = leven. Denk aan biologie (leer van het leven).",
          "2": "Water is 'hydro-' in het Grieks (hydraulisch = met water). Bio- = leven. Onthoud: bio = leven, hydro = water.",
          "3": "Lucht is 'aero-' in het Grieks (aerodynamisch = met lucht). Bio- = leven. Onthoud: bio = leven, aero = lucht."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.greek-origin-confused", "label": "Bio- verward met geo- (aarde)", "optionIndex": 0 },
          { "id": "spr.greek-origin-confused", "label": "Bio- verward met hydro- (water)", "optionIndex": 2 },
          { "id": "spr.greek-origin-confused", "label": "Bio- verward met aero- (lucht)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-LEEN-GRIEKS-004",
      "familyId": "SPR-LEEN-GRIEKS",
      "module": "SpellingRegel",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_grieks",
      "questionType": "multiple_choice",
      "question": "Welk woord is GEEN Grieks leenwoord?",
      "options": ["democratie", "telefoon", "theater", "garage"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Grieks vs. Frans", "content": "Garage is Frans (garer = bewaren). Democratie (demos = volk), telefoon (tele = ver, phone = geluid) en theater (theatron = schouwplaats) zijn Grieks.", "icon": "lightbulb" } }
      ],
      "conceptId": "grieks_niet_grieks",
      "variantIndex": 4,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Garage komt uit het Frans (garer = bewaren/stallen). Democratie, telefoon en theater komen allemaal uit het Grieks. Handige tip: herken Griekse woorddelen. Griekse woorden bevatten vaak herkenbare voor- en achtervoegsels: demo- (volk), tele- (ver), -foon (geluid), thea- (kijken). Franse woorden herken je aan uitgangen als -age (garage, bagage), -eur (chauffeur), -eau (cadeau). Door deze patronen te kennen, kun je de herkomst van onbekende woorden afleiden. Regel: als een woord een Grieks voor- of achtervoegsel bevat, is het waarschijnlijk een Grieks leenwoord.",
        "solutionSteps": [
          "Stap 1: Analyseer elk woord — bevat het een Grieks woorddeel?",
          "Democratie = demos (volk) + kratia (macht) → Grieks ✓",
          "Telefoon = tele (ver) + phone (geluid) → Grieks ✓",
          "Theater = theatron (schouwplaats) → Grieks ✓",
          "Garage = geen Grieks woorddeel, uitgang -age is typisch Frans → niet Grieks ✓"
        ],
        "distractorExplanations": {
          "0": "Democratie is juist WEL Grieks: demos (volk) + kratia (macht) = volksmacht. Analyseer het woord: demo- is een Grieks voorvoegsel dat je ook terugvindt in 'demografie'.",
          "1": "Telefoon is juist WEL Grieks: tele (ver) + phone (geluid) = ver geluid. Analyseer het woord: tele- vind je ook in 'televisie' en 'telescoop'.",
          "2": "Theater is juist WEL Grieks: theatron = schouwplaats. Het achtervoegsel -er/-ter komt vaak voor bij Griekse woorden.",
          "3": "Goed! Garage is Frans (van 'garer' = bewaren/stallen). De uitgang -age is typisch Frans, net als bij 'bagage' en 'massage'. Regel: -age = Frans, -logie/-grafie/-scopie = Grieks."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "spr.greek-origin-confused", "label": "Grieks woord niet herkend", "optionIndex": 0 },
          { "id": "spr.greek-origin-confused", "label": "Grieks woord niet herkend", "optionIndex": 1 },
          { "id": "spr.greek-origin-confused", "label": "Grieks woord niet herkend", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "SPR-LEEN-GRIEKS-005",
      "familyId": "SPR-LEEN-GRIEKS",
      "module": "SpellingRegel",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_grieks",
      "questionType": "matching",
      "question": "Koppel elk Grieks voorvoegsel aan de juiste betekenis.",
      "data": {
        "pairs": [
          { "left": "bio-", "right": "leven" },
          { "left": "geo-", "right": "aarde" },
          { "left": "tele-", "right": "ver" },
          { "left": "auto-", "right": "zelf" }
        ],
        "correctMatches": { "0": "0", "1": "1", "2": "2", "3": "3" }
      },
      "correctAnswer": { "0": "0", "1": "1", "2": "2", "3": "3" },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Griekse voorvoegsels", "content": "bio- = leven (biologie), geo- = aarde (geografie), tele- = ver (telefoon), auto- = zelf (automatisch). Denk aan bekende woorden om de betekenis te onthouden.", "icon": "lightbulb" } }
      ],
      "conceptId": "grieks_voorvoegsels_matching",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De Griekse voorvoegsels en hun betekenis: bio- = leven (biologie = leer van het leven), geo- = aarde (geografie = beschrijving van de aarde), tele- = ver (telefoon = ver geluid), auto- = zelf (automatisch = vanzelf werkend). Onthoud ze door aan bekende woorden te denken!",
        "solutionSteps": ["bio- = leven (denk aan: biologie)", "geo- = aarde (denk aan: geografie)", "tele- = ver (denk aan: telefoon)", "auto- = zelf (denk aan: automatisch)"],
        "distractorExplanations": {}
      }
    },
    {
      "id": "SPR-LEEN-GRIEKS-006",
      "familyId": "SPR-LEEN-GRIEKS",
      "module": "SpellingRegel",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_grieks",
      "questionType": "matching",
      "question": "Koppel elk Grieks voorvoegsel aan de juiste betekenis.",
      "data": {
        "pairs": [
          { "left": "mono-", "right": "één/alleen" },
          { "left": "poly-", "right": "veel" },
          { "left": "anti-", "right": "tegen" },
          { "left": "hyper-", "right": "boven/overmatig" },
          { "left": "micro-", "right": "klein" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Griekse voorvoegsels (2)",
            "content": "Nog meer Griekse voorvoegsels: mono- = één (monoloog = alleenspraak), poly- = veel (polygoon = veelhoek), anti- = tegen (antibiotica = tegen bacteriën), hyper- = boven/overmatig (hyperactief), micro- = klein (microscoop = klein kijken).",
            "icon": "book"
          }
        }
      ],
      "conceptId": "grieks_voorvoegsel_matching_2",
      "variantIndex": 6,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Griekse voorvoegsels en hun betekenis: mono- = één/alleen (monoloog = alleenspraak), poly- = veel (polygoon = veelhoek), anti- = tegen (antibiotica = tegen bacteriën), hyper- = boven/overmatig (hyperactief), micro- = klein (microscoop). Regel: als je een onbekend woord tegenkomt, kijk dan of het een Grieks voorvoegsel bevat. Analyseer het woord door het op te splitsen in woorddelen. Samen met de voorvoegsels uit de vorige vraag (bio-, geo-, tele-, auto-) ken je nu 9 Griekse voorvoegsels!",
        "solutionSteps": [
          "Stap 1: Splits elk woord in woorddelen om de betekenis te analyseren",
          "mono- = één (monoloog: mono + logos = alleen + spreken → alleenspraak)",
          "poly- = veel (polygoon: poly + goon = veel + hoek → veelhoek)",
          "anti- = tegen (antibiotica: anti + bios = tegen + leven → tegen bacteriën)",
          "hyper- = boven/overmatig (hyperactief: hyper + actief = overmatig actief)",
          "micro- = klein (microscoop: micro + scopie = klein + kijken)"
        ]
      },
      "pedagogy": {
        "dok": 3
      }
    },
    {
      "id": "SPR-LEEN-GRIEKS-007",
      "familyId": "SPR-LEEN-GRIEKS",
      "module": "SpellingRegel",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_grieks",
      "questionType": "matching",
      "question": "Koppel elk Grieks achtervoegsel aan de juiste betekenis.",
      "data": {
        "pairs": [
          { "left": "-logie", "right": "leer/wetenschap" },
          { "left": "-grafie", "right": "schrijven/beschrijven" },
          { "left": "-scopie", "right": "kijken/bekijken" },
          { "left": "-therapie", "right": "behandeling/genezing" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Griekse achtervoegsels",
            "content": "-logie = leer (biologie, psychologie). -grafie = schrijven (geografie, fotografie). -scopie = kijken (microscoop, telescoop). -therapie = behandeling (fysiotherapie).",
            "icon": "book"
          }
        }
      ],
      "conceptId": "grieks_achtervoegsel_matching",
      "variantIndex": 7,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Griekse achtervoegsels: -logie = leer/wetenschap (biologie, psychologie), -grafie = schrijven/beschrijven (geografie, fotografie), -scopie = kijken/bekijken (microscoop, telescoop), -therapie = behandeling/genezing (fysiotherapie). Regel: als je een onbekend woord tegenkomt met zo'n achtervoegsel, kun je de betekenis afleiden door het woord op te splitsen. Analyseer bijvoorbeeld 'cardiologie': cardio- (hart) + -logie (leer) = leer van het hart.",
        "solutionSteps": [
          "Stap 1: Splits elk woord in voor- en achtervoegsel",
          "bio-logie = leer van het leven → -logie = leer",
          "geo-grafie = beschrijving van de aarde → -grafie = schrijven",
          "micro-scopie = klein kijken → -scopie = kijken",
          "fysio-therapie = natuurlijke behandeling → -therapie = behandeling",
          "Stap 2: Pas toe op een nieuw woord — bijv. 'cardiografie' = beschrijving van het hart"
        ]
      },
      "pedagogy": {
        "dok": 3
      }
    },
    {
      "id": "SPR-LEEN-GRIEKS-008",
      "familyId": "SPR-LEEN-GRIEKS",
      "module": "SpellingRegel",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_grieks",
      "questionType": "categorize",
      "question": "Sorteer deze woorden: komen ze uit het Grieks of uit een andere taal?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Grieks", "Niet Grieks"],
        "items": [
          { "text": "biologie", "correctCategory": 0 },
          { "text": "restaurant", "correctCategory": 1 },
          { "text": "telefoon", "correctCategory": 0 },
          { "text": "computer", "correctCategory": 1 },
          { "text": "democratie", "correctCategory": 0 },
          { "text": "cadeau", "correctCategory": 1 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Griekse woorden herkennen", "content": "Griekse woorden herken je aan typische woorddelen:\nbio- (leven), tele- (ver), demo- (volk), -logie (leer), -grafie (schrijven)\n\nRestaurant = Frans, computer = Engels, cadeau = Frans.", "icon": "lightbulb" } }
      ],
      "conceptId": "grieks_categorize",
      "variantIndex": 8,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Grieks: biologie (bio = leven + logie = leer), telefoon (tele = ver + foon = geluid), democratie (demo = volk + cratie = macht). Niet Grieks: restaurant (Frans), computer (Engels), cadeau (Frans). Regel: analyseer elk woord door het op te splitsen in woorddelen. Bevat het een Grieks voor- of achtervoegsel (bio-, tele-, demo-, -logie, -grafie)? Dan is het waarschijnlijk Grieks. Herken je een Frans kenmerk (-eau, -ant, -eur)? Dan is het Frans.",
        "solutionSteps": [
          "Stap 1: Analyseer elk woord — splits het op in woorddelen",
          "Biologie → bio- (Grieks: leven) + -logie (Grieks: leer) → Grieks ✓",
          "Restaurant → -ant uitgang (Frans kenmerk) → niet Grieks",
          "Telefoon → tele- (Grieks: ver) + -foon (Grieks: geluid) → Grieks ✓",
          "Computer → Engels (to compute = berekenen) → niet Grieks",
          "Democratie → demo- (Grieks: volk) + -cratie (Grieks: macht) → Grieks ✓",
          "Cadeau → -eau uitgang (Frans kenmerk) → niet Grieks"
        ]
      },
      "pedagogy": {
        "dok": 3
      }
    },
    {
      "id": "SPR-LEEN-GRIEKS-009",
      "familyId": "SPR-LEEN-GRIEKS",
      "module": "SpellingRegel",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_grieks",
      "questionType": "error_spotting",
      "question": "Zoek de spelfout in deze tekst en verbeter het woord.",
      "data": {
        "text": "In de les biologie leerden we over fotosynthese. De leraar legde uit dat 'filo' in filosofy 'liefde' betekent en 'sofie' 'wijsheid'. Zo is filosofie letterlijk 'liefde voor wijsheid'.",
        "errors": [
          {
            "word": "filosofy",
            "position": 18,
            "correction": "filosofie",
            "explanation": "'Filosofy' gebruikt de Engelse uitgang -y. In het Nederlands wordt de Engelse -y vervangen door -ie: philosophy → filosofie. Andere voorbeelden: biology → biologie, psychology → psychologie."
          }
        ]
      },
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Griekse woorden in het Nederlands", "content": "Griekse woorden worden in het Nederlands aangepast: ph → f, -y → -ie. Philosophy → filosofie (niet filosofy). Biology → biologie. Psychology → psychologie.", "icon": "lightbulb" } }],
      "conceptId": "grieks_error_spotting",
      "variantIndex": 9,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "'Filosofy' is fout — het gebruikt de Engelse uitgang -y. In het Nederlands wordt de Engelse -y vervangen door -ie: philosophy → filosofie. Regel: Griekse woorden worden in het Nederlands aangepast. De Griekse 'ph' wordt 'f', en de Engelse uitgang '-y' wordt '-ie'. Andere voorbeelden: biology → biologie, psychology → psychologie, geography → geografie. Let op: 'biologie' en 'fotosynthese' in de tekst zijn wél correct gespeld.",
        "solutionSteps": [
          "Lees de tekst en zoek woorden met Griekse oorsprong",
          "'Filosofy' heeft de Engelse uitgang -y",
          "Regel: Engelse -y → Nederlandse -ie",
          "Correctie: filosofy → filosofie",
          "Biologie en fotosynthese zijn correct ✓"
        ]
      },
      "pedagogy": {
        "dok": 3
      }
    }
  ]
}